export const html = `
<style>
  /* See https://jsfiddle.net/gristow/kj16t5q4/1/ */
  .rhythm-panel-outer {
    background-color: #ffa127;
    background-color: var(--bg-color);
    color: white;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    line-height: 1;
    border: 1px solid black;
  }

  .rhythm-panel-row {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    height: 100%;
    width: 100%;
  }

  .rhythm-panel-outer input[type='radio'],
  .rhythm-panel-outer button,
  .rhythm-panel-outer input[type='checkbox'] {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }

  .rhythm-panel-outer label {
    display: flex;
    flex-grow: 1;
    justify-content: center;
    border: 1px solid black;
    margin: 0px;
  }

  .rhythm-panel-outer label span {
    align-self: center;
    font-weight: lighter;
  }

  .rhythm-panel-outer input[type='radio']:checked + label,
  .rhythm-panel-outer button:active + label,
  .rhythm-panel-outer input[type='checkbox']:checked + label {
    box-shadow: inset 0.02em 0.02em 0.02em black, inset -0.02em -0.02em 0.02em white;
    text-shadow: -0.01em -0.01em 0.01em black;
    background-color: #17aae7;
    background-color: var(--pushed-bg-color);
  }

  .rhythm-panel-outer input[type='radio']:disabled + label,
  .rhythm-panel-outer button:disabled + label,
  .rhythm-panel-outer input[type='checkbox']:disabled + label {
    box-shadow: inset 0.02em 0.02em 0.02em black, inset -0.02em -0.02em 0.02em white;
    background-color: #ffd49b;
  }

  .rhythm-panel-outer input[type='radio']:focus + label,
  .rhythm-panel-outer button:focus + label,
  .rhythm-panel-outer input[type='checkbox']:focus + label {
    border-color: white;
  }

  .rhythm-panel-outer .smaller {
    font-size: 0.75em;
  }

  .rhythm-panel-outer .rest {
    display: var(--rest-visibility);
  }

  .rhythm-panel-outer .note {
    display: var(--note-visibility);
  }

  .rhythm-panel-outer .dot {
    display: var(--dot-visibility);
    transform: translateY(calc(var(--rest-selected) * (-0.3) * 1em));
  }

  .rhythm-panel-outer #dot-toggle,
  .rhythm-panel-outer #dot-toggle + label,
  .rhythm-panel-outer #dot-toggle + label + label {
    display: var(--second-row-dot-visibility);
  }

  .rhythm-panel-third-row {
    display: var(--third-row-visibility);
  }

  .rhythm-panel-outer #last-row-dot-toggle,
  .rhythm-panel-outer #last-row-dot-toggle + label,
  .rhythm-panel-outer #last-row-dot-toggle + label + label {
    display: var(--third-row-dot-visibility);
  }

  .rhythm-panel-outer #rest-toggle,
  .rhythm-panel-outer #rest-toggle + label,
  .rhythm-panel-outer #rest-toggle + label + label {
    display: var(--rest-toggle-visibility);
  }

  .rhythm-panel-outer #trash,
  .rhythm-panel-outer #trash + label {
    display: var(--trash-visibility);
  }

  .rhythm-panel-outer #add-note,
  .rhythm-panel-outer #add-note + label {
    display: var(--add-note-visibility);
  }

  .rhythm-panel-outer #check,
  .rhythm-panel-outer #check + label {
    display: var(--check-visibility);
  }
</style>

<div class="rhythm-panel-outer">
  <!-- Row 1 -->
  <div class="rhythm-panel-row">
    <input
      type="radio"
      id="breve"
      name="rhythm-panel-duration-radio"
      value="breve"
      aria-labelledby="aria-breve-label"
    />
    <label class="rhythm" for="breve" aria-hidden="true">
      <span class="note">1</span><span class="rest">!</span><span class="dot">.</span>
    </label>
    <label class="sr-only" for="breve" id="aria-breve-label">
      <span class="dot">Dotted </span><span class="note">Breve</span><span class="rest"> Rest</span>
    </label>

    <input
      type="radio"
      id="whole"
      name="rhythm-panel-duration-radio"
      value="whole"
      aria-labelledby="aria-whole-label"
    />
    <label class="rhythm" for="whole" aria-hidden="true">
      <span class="note">2</span><span class="rest">@</span><span class="dot">.</span>
    </label>
    <label class="sr-only" for="whole" id="aria-whole-label">
      <span class="dot">Dotted </span><span class="note">Whole</span><span class="rest"> Rest</span>
    </label>

    <input
      type="radio"
      id="half"
      name="rhythm-panel-duration-radio"
      value="half"
      aria-labelledby="aria-half-label"
    />
    <label class="rhythm" for="half" aria-hidden="true">
      <span class="note">3</span><span class="rest">#</span><span class="dot">.</span>
    </label>
    <label class="sr-only" for="half" id="aria-half-label">
      <span class="dot">Dotted </span><span class="note">Half</span><span class="rest"> Rest</span>
    </label>
  </div>

  <!-- Row 2 -->
  <div class="rhythm-panel-row">
    <input
      type="radio"
      id="quarter"
      name="rhythm-panel-duration-radio"
      value="quarter"
      aria-labelledby="aria-quarter-label"
    />
    <label class="rhythm" for="quarter" aria-hidden="true">
      <span class="note">4</span><span class="rest">$</span><span class="dot">.</span>
    </label>
    <label class="sr-only" for="quarter" id="aria-quarter-label">
      <span class="dot">Dotted </span><span class="note">Quarter</span
      ><span class="rest"> Rest</span>
    </label>

    <input
      type="radio"
      id="eighth"
      name="rhythm-panel-duration-radio"
      value="eighth"
      aria-labelledby="aria-eighth-label"
    />
    <label class="rhythm" for="eighth" aria-hidden="true">
      <span class="note">5</span><span class="rest">%</span><span class="dot">.</span>
    </label>
    <label class="sr-only" for="eighth" id="aria-eighth-label">
      <span class="dot">Dotted </span><span class="note">Eighth</span
      ><span class="rest"> Rest</span>
    </label>

    <input
      type="radio"
      id="sixteenth"
      name="rhythm-panel-duration-radio"
      value="sixteenth"
      aria-labelledby="aria-sixteenth-label"
    />
    <label class="rhythm" for="sixteenth" aria-hidden="true">
      <span class="note">6</span><span class="rest">^</span><span class="dot">.</span>
    </label>
    <label class="sr-only" for="sixteenth" id="aria-sixteenth-label">
      <span class="dot">Dotted </span><span class="note">Sixteenth</span
      ><span class="rest"> Rest</span>
    </label>

    <input
      type="checkbox"
      id="dot-toggle"
      aria-labelledby="aria-dot-label"
      onchange="document.querySelector('.rhythm-panel-outer #last-row-dot-toggle').checked = this.checked;"
    />
    <label class="rhythm dot-toggle" for="dot-toggle">
      <span>.</span>
    </label>
    <label class="sr-only dot-toggle" for="dot-toggle" id="aria-dot-label"> Dot </label>
  </div>

  <!-- Row 3 -->
  <div class="rhythm-panel-row rhythm-panel-third-row">
    <input type="checkbox" id="rest-toggle" aria-labelledby="aria-rest-label" />
    <label for="rest-toggle">
      <span class="rhythm smaller">1</span>/<span class="rhythm smaller">!</span>
    </label>
    <label class="sr-only" for="rest-toggle" id="aria-rest-label"> Rest </label>

    <input
      type="checkbox"
      id="last-row-dot-toggle"
      aria-labelledby="aria-last-row-dot-label"
      onchange="document.querySelector('.rhythm-panel-outer #dot-toggle').checked = this.checked;"
    />
    <label class="rhythm" for="last-row-dot-toggle">
      <span>.</span>
    </label>
    <label class="sr-only" for="last-row-dot-toggle" id="aria-last-row-dot-label"> Dot </label>

    <button id="trash" aria-labelledby="aria-trash-label">Trash</button>
    <label class="accidentals" for="trash">
      <span>†</span>
    </label>
    <label class="sr-only" for="trash" id="aria-trash-label"> Trash </label>

    <button id="add-note" aria-labelledby="aria-add-note-label">Add note to staff</button>
    <label class="rhythm" for="add-note">
      <span id="add-note-span">+4</span>
    </label>
    <label class="sr-only" for="add-note" id="aria-add-note-label"> Add note </label>

    <button id="check">Check</button>
    <label class="accidentals" for="check" aria-labelledby="aria-check-label">
      <span id="add-note-span">c</span>
    </label>
    <label class="sr-only" for="check" id="aria-check-label"> Check </label>
  </div>
</div>
`;
